import { render, staticRenderFns } from "./generalFund.vue?vue&type=template&id=5d7a0ca5"
import script from "./generalFund.vue?vue&type=script&lang=js"
export * from "./generalFund.vue?vue&type=script&lang=js"
import style0 from "./generalFund.vue?vue&type=style&index=0&id=5d7a0ca5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports